// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 159 ? "core_forsale" : chunkId) + "." + {"159":"e966884a","602":"2d9b7f6b"}[chunkId] + ".js";
};